import MonitoringQueueEntryScoringChangeStatusForm from './MonitoringQueueEntryScoringChangeStatusForm';

export default MonitoringQueueEntryScoringChangeStatusForm;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/change-status-form/index.js